'use strict';
// Generated by tsup.config.ts onSuccess. See that file for the compat rationale.
const Draggable = require('./Draggable.js');
const DraggableCore = Draggable.DraggableCore;
const Default = Draggable.default || Draggable;

module.exports = Default;
module.exports.default = Default;
module.exports.DraggableCore = DraggableCore;
